import { MembershipPlan } from 'react/types/membership_plan';
import plural from './plural';

export const hasRecurringClassAllowances = (membershipPlan: MembershipPlan) => {
  return (
    membershipPlan.classes_interval_unit &&
    membershipPlan.classes_interval_number > 0 &&
    membershipPlan.classes_limit > 0
  );
};

export const displayMissedClassMakeupClassDetails = (membershipPlan: MembershipPlan) => {
  if (!hasRecurringClassAllowances(membershipPlan)) return 'N/A';
  if (!membershipPlan.add_makeup_classes_for_missed_classes) return 'No action';
  if (
    membershipPlan.missed_class_replacement_strategy ===
    'generate_one_allowance_for_every_class_missed'
  ) {
    return 'Generate 1 make-up class for every class missed';
  } else {
    return `Generate up to ${membershipPlan.missed_class_replacement_fixed_number} make-up ${plural(
      'classes',
      membershipPlan.missed_class_replacement_fixed_number,
    )}`;
  }
};

export const displayMissedClassMakeupClassLimit = (membershipPlan: MembershipPlan) => {
  if (!membershipPlan.total_makeup_class_limit_for_missed_classes) return '';

  return `(Up to ${
    membershipPlan.total_makeup_class_limit_for_missed_classes
  } total make-up ${plural(
    'classes',
    membershipPlan.total_makeup_class_limit_for_missed_classes,
  )} generated automatically for the life of the membership)`;
};
